<template>
    <form v-else @submit.prevent="submitForm" class="quotetool__step">
        <div class="container">
            <h2 class="quotetool__step-heading">
                {{ labels.stepDropoutStepTitle }}
            </h2>
            <div class="quotetool__step-form-container">
                <p>{{ labels.stepDropoutStepDescription }}</p>
            </div> 
        </div>
    </form>
</template>

<script>
    import { mapState } from 'vuex';
    import StepNavigation from '../StepNavigation.vue'; 

    export default {
        components: {
            StepNavigation,  
        },


        computed: {
            ...mapState('microcopy', [
                'labels',
            ])
        }
    }
</script>